import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorCountryName } from "./selectorCountryName";
import { selectorMemberCountry } from "./selectorMemberCountry";

export const selectorMemberCountryName = (member: IMember) =>
  selectorCountryName(selectorMemberCountry(member));
